import React from 'react'
import { Formik } from 'formik'
import { Trans } from 'react-i18next';

import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'

const PortalLinkImageForm = ({
  initialValues,
  onValidate,
  onSubmit,
  onRequestClose,
  language = 'th',
}) => (
  <Formik
    enableReinitialize={true}
    initialValues={initialValues}
    onValidate={onValidate}
    onSubmit={onSubmit}
  >
    {({ values, errors, handleBlur, handleChange, handleSubmit }) => (
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">แก้ไขข้อมูลลิงค์</p>
          <button
            className="delete"
            aria-label="close"
            onClick={onRequestClose}
          />
        </header>
        <section className="modal-card-body">
          <Field label="ชื่อ">
            <InputText
              name={`title.${language}`}
              placeholder="ใส่ข้อความของคุณ (Ex.เข้าสู่เว็บไซต์,อ่านเพิ่มเติมได้ที่...)"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.title[language]}
              error={errors.title && errors.title[language]}
            />
          </Field>
          <Field label="ลิงค์ภายนอก">
            <InputText
              name={`externalUrl`}
              placeholder="ใส่ลิงค์เว็บไซต์ของคุณ (Ex. http://www.google.com)"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.externalUrl}
              error={errors.externalUrl}
            />
          </Field>
        </section>
        <footer
          className="modal-card-foot"
          style={{ justifyContent: 'flex-end' }}
        >
          <button className="button" onClick={onRequestClose}>
            <Trans>actions.cancel.label</Trans>
          </button>
          <button
            className="button is-success"
            onClick={handleSubmit}
            type="submit"
          >
            <Trans>actions.save.label</Trans>
          </button>
        </footer>
      </div>
    )}
  </Formik>
)

export default PortalLinkImageForm



// WEBPACK FOOTER //
// ./src/components/templates/portal-link/PortalLinkImageForm.js